import { buildArticle } from "./_articleBuilder";

export default buildArticle({
  slug: "how-many-tms-sessions-are-needed",
  title: "How Many TMS Sessions Are Typically Needed?",
  description:
    "The number of TMS sessions depends on the protocol — traditional TMS, accelerated TMS, or SAINT®. Learn what to expect from each treatment schedule.",
  keywords:
    "how many TMS sessions, TMS session count, SAINT sessions, accelerated TMS sessions",
  badge: "Educational Article",
  heroTitle: "How Many TMS Sessions Are Typically Needed?",
  heroSubtitle:
    "The number of sessions depends on which TMS protocol you're receiving. Traditional TMS, accelerated TMS, and SAINT® each have different schedules.",
  sections: [
    {
      heading: "Traditional TMS",
      body: "A traditional TMS course typically involves one session per day, five days a week, over several weeks. The total number of sessions is usually around 30 or more, spread across the course.",
    },
    {
      heading: "Accelerated TMS and SAINT®",
      body: "SAINT® delivers multiple sessions per day over five consecutive days — approximately 50 sessions total in a single week. The accelerated schedule compresses what is traditionally a multi-week course into days.",
    },
    {
      heading: "Why the Number Varies",
      body: "The exact number of sessions is a clinical decision based on the protocol, your history, and how you respond. Your care team determines the appropriate course during evaluation.",
    },
    {
      heading: "Maintenance Sessions",
      body: "Some people may discuss maintenance or follow-up sessions after the initial course. Whether maintenance is appropriate is a clinical decision made with your provider.",
    },
  ],
  faq: [
    {
      question: "Can I do fewer sessions?",
      answer:
        "The number of sessions is determined clinically based on the protocol and your individual situation. Changing the number of sessions isn't a personal preference — it's a clinical decision.",
    },
    {
      question: "Does SAINT® really take only five days?",
      answer:
        "The SAINT® protocol is delivered over five consecutive days with multiple sessions per day. The total number of sessions is similar to traditional TMS, but compressed into a shorter timeframe.",
    },
  ],
  related: [
    { title: "What Is TMS?", href: "/what-is-tms" },
    {
      title: "SAINT® vs. Traditional TMS",
      href: "/learn/saint-vs-traditional-tms",
    },
    {
      title: "Depression Treatment Options",
      href: "/depression-treatment-options",
    },
  ],
  finalCtaText:
    "Questions about the treatment schedule are normal. Speak with our team about what to expect.",
});
